import React from 'react';
import { clsx } from '../../utils';

function BackgroundImage(props) {
  var src = props.src,
      alt = props.alt,
      className = props.className,
      style = props.style;
  return /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    className: clsx('nivo-main-image', className),
    style: style
  });
}

BackgroundImage.displayName = "BackgroundImage";
export default BackgroundImage;